import { Component, input } from '@angular/core';
import { IReportCategory } from '../../pages/reports/reports.interface';
import { IconSvg } from '../icon-svg/icon-svg';

@Component({
  selector: 'app-report-category',
  imports: [IconSvg],
  templateUrl: './report-category.html',
  styleUrl: './report-category.css',
})
export class ReportCategory {
  categories = input.required<IReportCategory[]>();
}
